<template>
  <div class="uk-flex-center uk-margin-medium-top" uk-grid>

    <ErrorModal id="AddReplyErrorModal" message="There was an error adding your reply to the ticket. Please try again or contact support." />

    <div class="uk-width-2-3@l uk-width-1-1">
      <Card class="uk-margin-medium-bottom">

        <template v-slot:header>
          <div class="uk-flex uk-margin-remove uk-flex-middle uk-grid-match" uk-grid>
            <div class="uk-width-auto uk-padding-remove">
              <h2 class="uk-margin-remove-bottom">Ticket #{{ ticket.id }}:</h2>
            </div>
            <div class="uk-width-expand uk-margin-small-left uk-padding-remove uk-flex uk-flex-middle uk-text-truncate">
              <h4 class="uk-h4 uk-margin-remove">{{ ticket.summary }}</h4>
            </div>
          </div>
        </template>

        <template v-slot:body>
            <div class="uk-child-width-1-1 uk-grid-small uk-overflow-auto ba-max-height" uk-grid>
              <div class="" v-for="(reply, index) in ticket_replies" :key="index">
                <TicketReply :fullName="getTicketReplyFullName(index)" :date="getTicketReplyDate(index) | formatDate" :time="getTicketReplyTime(index)" :isAdmin="isReplyByAdmin(index)" :message="reply.details"></TicketReply>
                <hr v-if="index != (ticket_replies.length - 1)">
              </div>
            </div>

        </template>

        <template v-slot:footer>
          <div class="uk-grid-collapse uk-margin" uk-grid>
            <div class="uk-width-3-4@m uk-width-3-5">
              <input class="uk-input uk-form-large" placeholder="Type your reply here..." v-model="reply_text" rows="3" minlength="2" maxlength="500" required>
            </div>
            <div class="uk-width-1-4@m uk-width-2-5">
              <BitButton v-if="!spin" color="green" size="fill" @click.native="submit_ticket_reply()" :disabled="!reply_text">
                <span uk-icon="icon: comment;" class="buttonIcon"></span>
                Reply
              </BitButton>
              <BitButton v-if="spin" size="fill" color="green" disabled><div uk-spinner></div></BitButton>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import BitButton from '@/components/common/button.vue'
import Card from '@/components/common/card.vue'
import ErrorModal from '@/components/portal/errormodal.vue'
import TicketReply from '@/components/portal/ticketreply.vue'

import { mapActions, mapGetters } from "vuex";

import UIkit from 'uikit';

export default {
  name: 'ViewTicket',
  components: {
    BitButton,
    Card,
    ErrorModal,
    TicketReply,
  },
  data() {
    return {
      spin: false,
      reply_text: null
    }
  },
  computed: {
    ...mapGetters('tickets', ['getTicketById', 'getRepliesByTicketId']),
    ticket() {
      return this.getTicketById(this.$route.params.id)
    },
    ticket_replies() {
      return this.getRepliesByTicketId(this.$route.params.id)
    }
  },
  created() {
    this.GET_TICKET(this.$route.params.id)
  },
  methods: {
    ...mapActions('tickets', ['GET_TICKET', 'ADD_REPLY']),
    getTicketReplyFullName(index) {
      let reply = this.ticket_replies[index];
      return ( reply.first_name.charAt(0).toUpperCase() + reply.first_name.slice(1) ) + ' ' + ( reply.last_name.charAt(0).toUpperCase() + reply.last_name.slice(1) );
    },
    getTicketReplyDate(index) {
      let reply = this.ticket_replies[index];
      return reply.date_added.slice(0, 10);
    },
    getTicketReplyTime(index) {
      let reply = this.ticket_replies[index];
      return reply.date_added.slice(11,16);
    },
    isReplyByAdmin(index) {
      let reply = this.ticket_replies[index];
      return reply.staff_id ? true : false;
    },
    submit_ticket_reply() {
      this.spin = true;
      const reply = {
        ticket_id: this.$route.params.id,
        reply: this.reply_text
      };
      this.ADD_REPLY(reply)
        .then( () => {
          this.spin = false;
          this.reply_text = null;
        }).catch( () => {
          this.spin = false;
          UIkit.modal('#AddReplyErrorModal').show();
        })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/theme.less";

.uk-textarea {
  resize: none;
}
.ba-max-height {
  height: 600px;
  max-height: 600px;
}

</style>
